import React from 'react';
import clsx from 'clsx';
import { PlateElement, useSelected } from 'platejs/react';
import styles from './MentionElement.module.scss';

// Inline mention chip for a `{ type: 'mention', key, value }` node.
//
// The node is a void inline element (see BaseMentionPlugin: isInline +
// isVoid), so it has no editable text of its own — `node.value` (e.g.
// "@Jane Doe") is the display label and `node.key` is the mentioned user's
// id. We render the label inside a non-editable <span> and keep the slate
// void marker (props.children) as a sibling so the caret can sit either
// side of the chip without React/Slate complaining about editing a void.
//
// Mirrors LinkElement's PlateElement-based shape; styling lives in the
// colocated module.scss (purple accent matching the docx export).
export const MentionElement = React.memo(function MentionElement(props: any) {
    const selected = useSelected();
    const label = props?.element?.value ?? '';

    return (
        <PlateElement {...props} as="span" attributes={{ ...props.attributes, 'data-slate-value': label }}>
            <span contentEditable={false} className={clsx(styles.Mention, selected && styles.MentionSelected)}>
                {label}
            </span>
            {props.children}
        </PlateElement>
    );
});
